import React, { Component } from 'react';

class EventMediaViewer extends Component {
  constructor(props) {
    super(props);

    this.processFiles = this.processFiles.bind(this);
    this.onClickItem = this.onClickItem.bind(this);
  }

  processFiles() {
    let image = '';
    const { postInfo } = this.props;
    if (postInfo.data && postInfo.data.event_info) {
      image = postInfo.data.event_info.web_end_image_url;
    }
    return image;
  }

  onClickItem(e, postId) {
    e.preventDefault();
    if (this.props.type !== 'oldList' && this.props.onClickItem) {
      this.props.onClickItem(e, postId);
    }
  }

  render() {
    const { postInfo } = this.props;
    let image = this.processFiles();

    if (image === '') {
      return null;
    }

    return (
      <img
        src={image}
        style={this.props.type !== 'oldList' ? { cursor: 'pointer' } : null}
        onClick={(e, postId) => this.onClickItem(e, postInfo.id)}
        alt=""
      />
    );
  }
}

export default EventMediaViewer;
